import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let currentEntity = null;
export const setCurrentEntity = (slug) => {
  currentEntity = slug;
};

const client = axios.create({ baseURL: API });
client.interceptors.request.use((config) => {
  if (currentEntity) {
    config.params = { ...(config.params || {}), entity: currentEntity };
  }
  const token = localStorage.getItem("tf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const entityQS = () => (currentEntity ? `?entity=${currentEntity}` : "");

export const fetchBootstrap = () => client.get("/bootstrap").then((r) => r.data);
export const fetchTransactions = () => client.get("/transactions").then((r) => r.data);
export const fetchAnalytics = () => client.get("/analytics").then((r) => r.data);
export const fetchAnomalies = () => client.get("/anomalies").then((r) => r.data);
export const fetchAdmin = () => client.get("/admin").then((r) => r.data);
export const approveTransaction = (id) =>
  client.post(`/transactions/${id}/approve`, { actor: "reviewer_1" }).then((r) => r.data);
export const approveAll = () =>
  client.post("/transactions/approve-all", { actor: "reviewer_1" }).then((r) => r.data);
export const reclassifyTransaction = (id, coaAccount, train = false) =>
  client
    .post(`/transactions/${id}/reclassify`, { coa_account: coaAccount, actor: "reviewer_1", train })
    .then((r) => r.data);
export const uploadStatement = (filename, content, accountType = "checking") =>
  client.post("/upload", { filename, content, account_type: accountType }).then((r) => r.data);
export const askCopilot = (sessionId, message) =>
  client.post("/copilot", { session_id: sessionId, message }).then((r) => r.data);
export const copilotStreamUrl = () => `${API}/copilot/stream${entityQS()}`;
export const fetchStatements = () => client.get("/statements").then((r) => r.data);
export const fetchDepreciation = () => client.get("/depreciation").then((r) => r.data);
export const fetchWorkflow = () => client.get("/workflow").then((r) => r.data);
export const fetchExceptions = () => client.get("/exceptions").then((r) => r.data);
export const waiveException = (controlId, role, justification, actor) =>
  client
    .post("/exceptions/waive", { control_id: controlId, role, justification, actor })
    .then((r) => r.data);
export const raiseNote = (target, text, author = "reviewer_1") =>
  client.post("/workflow/notes", { target, text, author }).then((r) => r.data);
export const clearNote = (noteId, response, actor = "staff_1") =>
  client.post(`/workflow/notes/${noteId}/clear`, { response, actor }).then((r) => r.data);
export const signChecklist = (item, actor = "reviewer_1") =>
  client.post("/workflow/checklist", { item, actor }).then((r) => r.data);
export const transitionEngagement = (target, actor = "staff_1") =>
  client.post("/workflow/transition", { target, actor }).then((r) => r.data);
export const signOffEngagement = (actor, role) =>
  client.post("/workflow/signoff", { actor, role }).then((r) => r.data);
export const issueEngagement = (actor, role) =>
  client.post("/workflow/issue", { actor, role }).then((r) => r.data);
export const reopenEngagement = (reason) =>
  client.post("/workflow/reopen", { actor: "partner_1", role: "partner", reason }).then((r) => r.data);
export const fetchAjes = () => client.get("/ajes").then((r) => r.data);
export const proposeAje = (description, supportReference, lines, preparer = "staff_1") =>
  client
    .post("/ajes", { description, support_reference: supportReference, lines, preparer })
    .then((r) => r.data);
export const proposeDepreciationAje = () =>
  client.post("/ajes/depreciation", { actor: "staff_1" }).then((r) => r.data);
export const approveAje = (number, reviewer, role = "reviewer") =>
  client.post(`/ajes/${number}/approve`, { reviewer, role }).then((r) => r.data);
export const fetchBenchmarks = () => client.get("/benchmarks").then((r) => r.data);
export const fetchClientQueries = () => client.get("/client/queries").then((r) => r.data);
export const fetchFirmOverview = () => client.get("/firm/overview").then((r) => r.data);
export const fetchVault = () => client.get("/vault").then((r) => r.data);
export const createClient = (payload) => client.post("/clients", payload).then((r) => r.data);
export const archiveClient = (slug) => client.post(`/clients/${slug}/archive`).then((r) => r.data);
export const unarchiveClient = (slug) => client.post(`/clients/${slug}/unarchive`).then((r) => r.data);
export const deleteClient = (slug) => client.delete(`/clients/${slug}`).then((r) => r.data);
export const pdfExportUrl = () => {
  const p = new URLSearchParams();
  if (currentEntity) p.set("entity", currentEntity);
  const token = localStorage.getItem("tf_token");
  if (token) p.set("auth_token", token);
  return `${API}/export/pdf?${p.toString()}`;
};
export const queriesPdfUrl = () => {
  const p = new URLSearchParams();
  if (currentEntity) p.set("entity", currentEntity);
  const token = localStorage.getItem("tf_token");
  if (token) p.set("auth_token", token);
  return `${API}/export/queries.pdf?${p.toString()}`;
};

export const submitServiceRequest = (payload) =>
  client.post("/v1/service-requests", payload).then((r) => r.data);
export const signInRequest = (email, password) =>
  client.post("/v1/auth/signin", { email, password }).then((r) => r.data);
export const registerRequest = (fullName, email, password) =>
  client.post("/v1/auth/register", { full_name: fullName, email, password }).then((r) => r.data);
export const forgotPassword = (email) =>
  client.post("/v1/auth/forgot-password", { email }).then((r) => r.data);
export const resetPassword = (token, newPassword) =>
  client.post("/v1/auth/reset-password", { token, new_password: newPassword }).then((r) => r.data);
export const fetchMe = () => client.get("/v1/auth/me").then((r) => r.data);
export const checkEmailExists = (email) =>
  client.get("/v1/auth/check-email", { params: { email } }).then((r) => r.data);
export const fetchDigest = () => client.get("/digest").then((r) => r.data);
export const sendDigest = (recipientEmail) =>
  client.post("/digest/send", { recipient_email: recipientEmail }).then((r) => r.data);
export const fetchMyRequests = () => client.get("/v1/my/service-requests").then((r) => r.data);
export const uploadAttachment = (requestId, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return client.post(`/v1/service-requests/${requestId}/attachments`, fd).then((r) => r.data);
};
export const attachmentDownloadUrl = (attachmentId) => {
  const token = localStorage.getItem("tf_token");
  return `${API}/v1/attachments/${attachmentId}/download?auth_token=${encodeURIComponent(token || "")}`;
};
export const processAttachment = (attachmentId) =>
  client.post(`/attachments/${attachmentId}/process`).then((r) => r.data);
export const getDigestSchedule = () => client.get("/digest/schedule").then((r) => r.data);
export const setDigestSchedule = (recipientEmail, enabled) =>
  client.post("/digest/schedule", { recipient_email: recipientEmail, enabled }).then((r) => r.data);
export const fetchAllRequests = () => client.get("/v1/staff/service-requests").then((r) => r.data);
export const updateRequestStatus = (id, status) =>
  client.patch(`/v1/staff/service-requests/${id}/status`, { status }).then((r) => r.data);
export const convertRequest = (id, legalName, entityType) =>
  client
    .post(`/v1/staff/service-requests/${id}/convert`, { legal_name: legalName, entity_type: entityType })
    .then((r) => r.data);
